<template>
    <q-dialog v-model="showModal" persistent>
        <recipient-form v-model="recipient" @submit="addRecipient" :saving="loading" v-if="recipient"/>
    </q-dialog>
</template>
<script>

import RecipientForm from "../components/RecipientForm"
import { RecipientMixin } from '../mixins/RecipientMixin'

export default {
    name: "RecipientModal",
    mixins: [ RecipientMixin ],
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        recipientId: {
            type: Number,
            default: 0
        },
        user: {
            type: Object,
            default: ()=>{}
        },
        destCurrency: {
            type: String,
            default: ''
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        addRecipient() {
            this.loading = true
            this.recipient.create((data) => {
                this.loading = false
                this.showModal = false
                this.$emit('created', data)
                this.recipient.initialize()
            }).catch(error => {
                this.loading = false
            })
        },
        fetchRecipientToEdit() {
            this.recipient.id = this.recipientId
            this.recipient.fetch(recipient => {
                this.$q.loading.hide()
            }).catch(error => {
                this.$q.loading.hide()
                this.$q.notify({
                    message: 'An error has occurred!',
                    color: 'negative'
                });
                this.$router.push({name: 'recipients.list'})
            })
        }
    },
    created() {

    },
    mounted() {
        if(this.user && this.user.id) {
            this.recipient.user = this.user
        }

        this.recipient.currency_acronym = this.destCurrency || this.$q.cookies.get('last_to_currency') || 'VND'
    },
    components: {
        RecipientForm,
    },
}
</script>
<style>

</style>
